import {
  translateHelpLink,
  getHelplink,
  getAllHelplinks,
  getHelpLoginLink,
  normaliseLocale,
} from './helpLinks/helpLinks.helpers';
import { getCSSLocale } from './cssLocale/cssLocale.helpers';
import { helpPaths } from './helpLinks/helpLinks.constants';
import {
  getHelpLinkParams,
  GetAllHelplinksParams,
  getHelpLoginLinkParams,
} from './helpLinks/helpLinks.types';

export class Localisation {
  /* Helplinks */
  public static translateHelpLink({
    helpLink,
    locale,
  }: {
    helpLink: string;
    locale: string;
  }) {
    return translateHelpLink({ helpLink, locale });
  }

  public static getHelpLink({ key, locale }: getHelpLinkParams) {
    return getHelplink({
      key,
      locale,
    });
  }

  public static normaliseLocale(locale: string) {
    return normaliseLocale(locale);
  }

  // you only need to set environment if you want to have a different environment than 'live'
  // e.g. for testing with a sandbox
  public static getAllHelpLinks({
    locale,
    environment,
    zendeskToken,
  }: GetAllHelplinksParams) {
    return getAllHelplinks({ locale, environment, zendeskToken });
  }

  public static getHelpLoginLink({
    environment,
    zendeskToken,
  }: getHelpLoginLinkParams) {
    return getHelpLoginLink({ environment, zendeskToken });
  }

  public static readonly helpPaths = helpPaths; // to use as a default before loading language files

  /* CSS Locale */
  public static readonly getCSSLocale = (locale: string): string => {
    return getCSSLocale(locale);
  };
}
